import script from "./ClientsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanel.vue?vue&type=style&index=0&id=4dbfb877&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbfb877"]])

export default __exports__